import script from "./schema-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./schema-editor.vue?vue&type=script&setup=true&lang=js"

import "./schema-editor.vue?vue&type=style&index=0&id=fd0809fe&lang=scss"

const __exports__ = script;

export default __exports__